import { render } from "./DropDownItem.vue?vue&type=template&id=c955c0aa&scoped=true"
import script from "./DropDownItem.vue?vue&type=script&lang=js"
export * from "./DropDownItem.vue?vue&type=script&lang=js"

import "./DropDownItem.vue?vue&type=style&index=0&id=c955c0aa&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c955c0aa"]])

export default __exports__